var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6534 14.2387C18.2897 10.9025 18.0677 6.04639 14.9875 2.96615C11.668 -0.353302 6.2861 -0.353302 2.96664 2.96615C-0.352813 6.28561 -0.352813 11.6675 2.96664 14.987C6.04688 18.0672 10.903 18.2892 14.2392 15.6529L17.8159 19.2296C18.2064 19.6201 18.8396 19.6201 19.2301 19.2296C19.6206 18.8391 19.6206 18.2059 19.2301 17.8154L15.6534 14.2387ZM13.5732 4.38037C16.1117 6.91878 16.1117 11.0343 13.5732 13.5728C11.0348 16.1112 6.91926 16.1112 4.38086 13.5728C1.84245 11.0343 1.84245 6.91878 4.38086 4.38037C6.91926 1.84196 11.0348 1.84196 13.5732 4.38037Z",
    fill: "#EDEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ad39055de41d7d7840f174d1daaf66a9.svg";
export { ForwardRef as ReactComponent };